export const getFilename = (fileName: string | undefined) => fileName?.replace(/\.[^/.]+$/, '');
